import { createPivotTransformer } from './create-pivot-transformer';

/** Pivot = meters. */
export const LENGTH_PIVOT: Record<string, number> = {
  m: 1,
  in: 0.0254,
  ft: 0.3048,
  yd: 0.9144,
  mi: 1609.344,
  mm: 0.001,
  cm: 0.01,
  km: 1000,
  mil: 0.0000254,
  um: 1e-6,
  nm: 1e-9,
};

export const transformLength = createPivotTransformer(LENGTH_PIVOT);
